module.exports = __webpack_public_path__ + "fonts/Angkasa-Regular-2.45aab319.otf";